import Main from "./component.main";
import store from "./script.store";
import { LeftBar } from "../../components";
const Broadcast = { LeftBar, Main, store };
export default Broadcast;
